import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id 77550809-9FBB-4283-BA57-7C48AB2B86C0
 * name angle-right
 * version: 2.4.85
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/angle-right.svg
 * tags
 * - Math 
 */
export const AngleRightIcon = createSvgIcon(<><path d="M5,4H7V11H13V17H20V19H5V4M7,17H11V13H7V17Z" /></>, 'AngleRightIcon');
export default AngleRightIcon